import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { EMPTY } from 'rxjs/internal/observable/empty';
import { filter } from 'rxjs/internal/operators/filter';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { take } from 'rxjs/internal/operators/take';
import {
  MhsIdentityApiClient,
  NhfAccessChangePasswordRequest,
  NhfAccessRowItemSearchResult,
  P1Profile,
  SettlementProfile,
} from '../../../core/api/mhsIdentityApiClient';
import { MhsInternalApiClient } from '../../../core/api/mhsInternalApiClient';
import { AuthStore } from '../../../core/authentication/authStore';
import { UsertStore } from '../../../core/context/userStore';

@Injectable({
  providedIn: 'root',
})
export class NfzService {
  identityApiClient = inject(MhsIdentityApiClient);
  internalApiClient = inject(MhsInternalApiClient);
  authStore = inject(AuthStore);
  userStore = inject(UsertStore);

  searchNhfAccess(
    pageIndex: number,
    pageSize: number,
    orderBy?: string,
    isOrderByAsc?: boolean,
  ): Observable<NhfAccessRowItemSearchResult> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }

    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.identityApiClient.nhfAccess_Search(pageIndex, pageSize, orderBy, isOrderByAsc);
      }),
    );
  }
  searchP1Access(): Observable<P1Profile[]> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.identityApiClient.nhfProfile_GetP1ReferralProfiles();
      }),
    );
  }
  searchSettlementsProfiles(): Observable<SettlementProfile[]> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.identityApiClient.nhfSettelmentsProfile_GetP1ReferralProfiles();
      }),
    );
  }

  searchSettelemntsProfiles(): Observable<SettlementProfile[]> {
    return this.searchSettlementsProfiles();
  }
  changeEwusKolcePassword(id: number, oldPassword: string, newPassword: string): Observable<void> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.identityApiClient.nhfAccess_ChangePassword(
          new NhfAccessChangePasswordRequest({
            id: id,
            oldPassword: oldPassword,
            newPassword: newPassword,
          }),
        );
      }),
    );
  }
  changeSettlementsPassword(
    serviceProvider: string,
    oldPassword: string,
    newPassword: string,
  ): Observable<void> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.identityApiClient.nhfSettelmentsProfile_UpdatePassword(
          serviceProvider,
          oldPassword,
          newPassword,
        );
      }),
    );
  }
}
